import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * FloatingLabBack — a small floating "Back to Labs" pill that renders in the
 * top-left corner of every `/labs/*` route (but not on the `/labs` landing
 * page itself).  This gives users a guaranteed way to return to the Visual
 * Labs landing page even if a particular lab component has no back button of
 * its own or wires its back button to the browser history.
 */
export default function FloatingLabBack() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Only show when we're INSIDE a lab (deeper than /labs itself).
  if (!pathname.startsWith('/labs/')) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/labs')}
      data-testid="floating-lab-back"
      className="fixed top-3 left-3 z-[9999] inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold
                 bg-white/85 dark:bg-slate-900/85 backdrop-blur border border-slate-200 dark:border-slate-700
                 shadow-lg hover:shadow-xl hover:bg-white dark:hover:bg-slate-800
                 transition-all"
      aria-label="Back to Visual Labs"
    >
      <ArrowLeft className="w-3.5 h-3.5" />
      Back to Labs
    </button>
  );
}
